(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  // Keep collection counts and pagination restricted to available products.
  if (url.searchParams.get("filter.v.availability") !== "1") {
    url.searchParams.set("filter.v.availability", "1");
    url.searchParams.delete("page");
    window.location.replace(url.toString());
  }
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
  const searchUrl = new URL(window.location.href);
  if (searchUrl.searchParams.get('filter.v.availability') !== '1') {
    searchUrl.searchParams.set('filter.v.availability', '1');
    searchUrl.searchParams.delete('page');
    window.location.replace(searchUrl.toString());
  }

  } catch(e) { console.error(e); }
})();
})();
